import React from 'react'
import './Section.css'



// function Section(props) {
function Section({id,title, description, backgroundImg, leftBtnText, rightBtnText}) {
    return (
        <div id='1' className='wrap' style={{backgroundImage: `url(/images/${backgroundImg})`,}}>
            <div className="itemText fadeBottom">
                {/* <h1>props.title</h1>        --> if we just simply use this ------ >function Section(props)  */}  
                <h1>{ title }</h1>
                <p>{ description }</p>
            </div>
            {/* */}

            <div className="buttons">

                <div className="buttonGroup">
                    <div className="sectionButton leftButton">{ leftBtnText }</div>
                    {/* does right button Text exisit or not checking only then show right button*/}
                    {rightBtnText && <div className="sectionButton rightButton">{ rightBtnText }</div>} 
                </div>
                <div className="downArrow">
                    <img src="/images/down-arrow.svg" alt="" />
                </div>
            </div>
        </div>
    )
}

export default Section
